import React, { useEffect, useState } from "react";

import "./style.css"
import Typography from '@mui/material/Typography';
import { Button, Container, Link, TextField, useMediaQuery } from "@mui/material";
import {createErrorToast, createInfoToast} from "../../utils/toasts/createToast";
import api from "../../services/api";
import validarEmail from "../../utils/funcoes/validacoes/validarEmail";

/* Imagens e icones*/
import iconFX from '../../assets/fx_sistemas_logo.png';
import logoNotaCerta from '../../assets/notaCertaBlack.png';
import logoBestZap from '../../assets/bestzap.png'; 
import { i18n } from "../../translate/i18n";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PatternFormat } from "react-number-format";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright "}
      <Link color="inherit" href="https://www.fxsistemas.com.br" target="_blank">
        FX Sistemas
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

const Login = () => {
  const [email, setEmail] = useState('')
  const [nome, setNome] = useState('')
  const [telefone, setTelefone] = useState('')
  const [planoId, setPlanoId] = useState(0)
  const [sistemaId, setSistemaId] = useState(0)
  const [slug, setSlug] = useState('')
  const isSmallScreen = useMediaQuery('(max-width:825px)');
  const navigate = useNavigate();
  const handleNavigateTo = (path) => { navigate(path); };
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const plano = searchParams.get('planoId') || 0;
    setPlanoId(plano);
    
    const sistema = searchParams.get('sistemaId') || 1;
    setSistemaId(sistema);
    
    const slug = searchParams.get('parceiro') || '';
    setSlug(slug);

    // const parceiroSearch = async () => {
    //   const {data: dataAfiliado} = await api.get("/v1/afiliados/slug/"+slug);
    //   setParceiro(`Indicação de ${dataAfiliado?.nome}.`);
    // }
    // parceiroSearch();

  }, [searchParams]);
  
  const systemNames = {
    1: 'Nota Certa', 
    2: 'BestZap'
  };
  const systemName = systemNames[sistemaId] || systemNames[1];

  const backgroundColors = {
    1: 'linear-gradient(-45deg, #5a7fc7, #4f9ebd, #38b8b6)',
    2: 'linear-gradient(-45deg, #e76d7b, #b8154f)'
  };
  const backgroundStyle = backgroundColors[sistemaId] || backgroundColors[1];
  
  const logos = {
    1: logoNotaCerta, 
    2: logoBestZap
  };
  const logoSrc = logos[sistemaId] || logoNotaCerta;

  const handleChangeEmailInput = (e) => {
    setEmail(e.target.value);
  };

  const handleChangeNomeInput = (e) => {
    const regex = /^[A-Za-zÀ-ÿ ]*$/;
    if (regex.test(e.target.value)) {
      setNome(e.target.value); 
    }
  };
  const handleChangeTelefoneInput = (e) => {
    setTelefone(e.target.value);
  };

  const handleSubmit = async() => {    
    try {
      if (nome === '') {
        createInfoToast('Por favor, informe seu nome.')
      } else if (email === '') {
        createInfoToast('Por favor, informe seu e-mail.')
      } else if (!validarEmail(email)) {
        createInfoToast('Por favor, informe um e-mail válido.')
      } else if (telefone === '') {
        createInfoToast('Por favor, informe seu celular.')
      }
      else {
        const { data } = await api.post('/hashInfo', { email,nome,telefone,planoId,sistemaId,sistemaNome:systemName,slug });
        if (data.type === 'warning') {
          createInfoToast(data.message)
        } else if (data.type === 'error') {
          createErrorToast(data.message)
        } else {
          handleNavigateTo("/verificacao");
        }
      }

    } catch (error) {
      createErrorToast('Não foi possível cadastrar o email. Tente novamente mais tarde.');
    }

  };

  return (    
    <div className="login-backGround" style={{ background: backgroundStyle }}>
      <Container className={isSmallScreen ? "loginSmall" : "loginDesktop"}>
        <img 
          alt="Pagamento" 
          id={isSmallScreen ? "logoTipoSmall" : "logoTipoDesktop"}
          src={logoSrc} 
        />

        <Typography id={isSmallScreen ? "tituloLoginSmall" : "tituloLoginDesktop"}>
          Seja bem-vindo ao {systemName}, por favor, informe seus dados para continuar.
        </Typography>

        <div className="form">
          <center>          
            <TextField
              autoFocus
              variant="outlined"
              margin="normal"
              required
              style={{width:"100%"}}
              id="nome"
              label={i18n.t("login.form.name")}
              name="nome"
              value={nome}
              onChange={handleChangeNomeInput}
              autoComplete="nome"
            />  

            <TextField
              variant="outlined"
              margin="normal"
              required
              style={{width:"100%"}}
              id="email"
              label={i18n.t("login.form.email")}
              name="email"
              value={email}
              onChange={handleChangeEmailInput}
              autoComplete="email"
            />  

            <PatternFormat
              autoComplete="telefone"
              customInput={TextField}
              format='(##) #########'
              variant="outlined"
              margin="dense"
              required
              fullWidth={isSmallScreen}
              label={i18n.t("login.form.fone")}
              name="telefone"
              style={{width:"100%"}}
              value={telefone}
              onChange={handleChangeTelefoneInput}
            />  

            <br></br>
            <br></br>
            {/* <Typography id={isSmallScreen ? "tituloLoginSmall" : "tituloLoginDesktop"}>
              {parceiro}
            </Typography> */}

            <Button 
              style={{width: "50%", height: "50px"}}
              variant="contained"
              color="primary"    
              onClick={handleSubmit}          
            >
              {i18n.t("login.buttons.continue")} 
            </Button>  
          
            <a href="https://www.fxsistemas.com.br" target="_blank" rel="noopener noreferrer">
              <img id="logoFx" src={iconFX} alt="FX Sistemas Logo" />  
            </a>
            { <Copyright /> }
          </center>                    
        </div>                                                                                                     
      </Container>      
    </div>

  );
};

export default Login;